function initialValues() {
  return {
    password: '',
    passwordConfirm: '',
  };
}

export default initialValues;
